<template>
  <div
    class="frpl frpl_wrapper"
    style="--txt-b-clr: var(--clr-white-0)"
    @scroll="handleScroll"
  >
    <div class="frpl_content">
      <section
        class="frpl_header f-center f-column"
        style="position: relative; width: 100%"
      >
        <div class="frpl_header-text uppercase text-nowrap line-height_1 font-clash-semibold">
          <div class="frpl_main-text">
            <div style="z-index: 1">
              {{ $t('fairplay.title') }}
            </div>
            <div class="frpl_shadow">{{ $t('fairplay.title') }}</div>
          </div>
        </div>
        <div
          class="f-center clr-grey text-normal-large mt-4"
          v-html="$t('fairplay.subtitle')"
        />
        <div class="frpl_buttons mt-12">
          <div
            class="gw_btn gw_btn_primary weight_600 text-normal"
            style="--height: 2.375rem; --padding: 1.5rem"
            @click="scrollTo('fairplay')"
          >
            {{ $t('fairplay.try_button') }}
          </div>
          <div
            class="gw_btn gw_btn_text weight_600 text-normal clr-white"
            style="--height: 2.375rem; --padding: 1.5rem; --border: 1px solid #fdfdfd1a"
            @click="scrollTo('boxes')"
          >
            {{ $t('fairplay.learn_more') }}
          </div>
        </div>

        <div style="position: absolute; z-index: 0; width: 100%; height: 100%">
          <DiamondSvg
            class="frpl_symbol frpl_symbol_mobile"
            style="
              inset: -23% auto auto -26%;
              transform: rotate(38deg) scale(0.3);
              opacity: 0.8;
              filter: blur(10px);
            "
          />
          <ClubSvg
            class="frpl_symbol frpl_symbol_mobile"
            style="
              inset: 34% auto auto -12%;
              transform: rotate(38deg) scale(0.4);
              opacity: 0.8;
              filter: blur(6px);
            "
          />
          <HeartSvg
            class="frpl_symbol frpl_symbol_mobile"
            style="
              inset: -5% -24% auto auto;
              transform: rotate(38deg) scale(0.35);
              opacity: 0.8;
              filter: blur(8px);
            "
          />
          <SpadeSvg
            class="frpl_symbol"
            style="
              opacity: 0.8;
              filter: blur(2px);
              inset: 57% -2% auto auto;
              transform: rotate(-34deg) scale(0.46);
            "
          />
        </div>
      </section>

      <section id="boxes">
        <h2>{{ $t('fairplay.our_actions') }}</h2>
        <div class="frpl_boxes">
          <div
            v-for="(box, index) in boxes"
            :key="index"
            class="frpl_box"
            :class="box.cssClass"
            :style="`--background-url:url(${box.img});` + box.cssStyles"
            @click="
              () => {
                box.onclick && box.onclick()
              }
            "
          >
            <div
              class="mdi mr-2 mt-auto"
              style="font-size: 2.25rem"
              :class="box.icon"
            ></div>
            <div class="frpl_box_title text-normal-large weight_600 f-center">
              <div v-html="box.title"></div>
              <i
                v-if="box.onclick"
                class="mdi mdi-arrow-right frpl_arrow ml-auto"
              />
            </div>
            <div class="frpl_divider" />
            <div class="frpl_description">
              {{ box.description }}
            </div>
          </div>
        </div>
      </section>

      <section>
        <h2>{{ $t('fairplay.integration.title') }}</h2>
        <div
          class="clr-grey text-normal-large"
          v-html="$t('fairplay.integration.text')"
        ></div>
      </section>
      <section>
        <h3>{{ $t('fairplay.partners') }}</h3>
        <div class="frpl_partners">
          <img
            v-for="partner in partners"
            :key="partner"
            :src="getImage(`partners/${partner}.webp`)"
            :alt="partner"
          />
          <div
            class="font-clash-semibold clr-grey mt-auto line-height_1"
            style="font-size: 2rem"
          >
            & more coming soon
          </div>
        </div>
      </section>
      <section id="reviews">
        <ReviewSlider
          class="frpl_slider_wrapper"
          :items="reviews"
          style="
            --height: var(--rrw-height);
            --inset-arrow-left: var(--rrw-inset-arrow-left);
            --inset-arrow-right: var(--rrw-inset-arrow-right);
          "
        >
          <template #default="{ item }">
            <div class="frpl_slider">
              <div
                class="h-100 frpl_slider_avatar"
                :style="`--background-url:url(${item.img})`"
              ></div>
              <div class="frpl_slider_right px-6">
                <div class="clr-grey frpl_slider_right_text">
                  {{ item.text }}
                </div>
                <div class="frpl_slider_right_bio">
                  <div class="text-normal-large weight_500 mt-1">
                    {{ item.name }}
                  </div>
                  <div
                    class="clr-grey text-small d-flex"
                    style="margin-top: 0.25rem"
                  >
                    <img
                      v-if="item.siteLogo"
                      style="height: 1.25rem; margin-right: 0.5rem"
                      class="my-auto"
                      :src="item.siteLogo"
                    />
                    <div class="my-auto">
                      {{ item.profession }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </ReviewSlider>
      </section>

      <section
        v-if="!$i18n.g1"
        id="read_more"
      >
        <div class="fff-read-more">
          <h2
            style="margin: 0"
            v-html="
              $t('fairplay.article', {
                vision: `<a target='_blank' href='${readMoreLink}' class='text-underline clr-white'>vision</a>`,
              })
            "
          ></h2>
          <a
            :href="readMoreLink"
            target="_blank"
            class="gw_btn gw_btn_text text-normal weight_600 clr-white"
            style="--height: 2.375rem; --padding: 1.5rem; --border: 1px solid #fdfdfd1a"
          >
            {{ $t('common.read_more') }}
          </a>
        </div>
      </section>

      <section
        id="fairplay"
        class="f-column f-center full-h-border"
        style="padding: 7.5rem 0"
      >
        <div class="f-column w-100">
          <h2>{{ $t('fairplay.fairplay.title') }}</h2>
          <div
            class="clr-grey text-normal-large"
            v-html="$t('fairplay.fairplay.text')"
          ></div>
        </div>
        <FairplayPicker
          ref="fairPlayPicker"
          @set:game="setGame"
        />
        <FairplayGames :game="l_game" />
      </section>

      <section>
        <h2>{{ $t('fairplay.about.title') }}</h2>
        <div
          class="clr-grey text-normal-large"
          v-html="$t('fairplay.about.text')"
        ></div>
      </section>
    </div>
  </div>
</template>

<script>
import ClubSvg from '@/assets/fairplay/Club.svg'
import DiamondSvg from '@/assets/fairplay/Diamond.svg'
import HeartSvg from '@/assets/fairplay/Heart.svg'
import SpadeSvg from '@/assets/fairplay/Spade.svg'
import ReviewSlider from '@/views/fairplay/ReviewSlider'
import FairplayPicker from '@/views/fairplay/FairplayPicker'
import FairplayGames from '@/views/fairplay/FairplayGames'
import float_mix from '@/mixins/float_mix'
import screen_mix from '@/mixins/screen_mix'
import { nextTick } from 'vue'

export default {
  name: 'FairPlay',
  components: {
    ClubSvg,
    DiamondSvg,
    HeartSvg,
    ReviewSlider,
    SpadeSvg,
    FairplayPicker,
    FairplayGames,
  },
  mixins: [float_mix, screen_mix],
  data() {
    return {
      partners: ['WPN', 'WPT'],
      l_game: {
        cards: null,
        time: null,
      },
    }
  },
  mounted() {
    if (this.$route.query.scrollTo) {
      nextTick(() => {
        this.scrollTo(this.$route.query.scrollTo)
      })
    }
  },
  methods: {
    getImage(img) {
      return new URL(`/src/assets/fairplay/${img}`, import.meta.url).href
    },
    getLogo(logo) {
      return new URL(`/src/assets/playhouses/${logo}`, import.meta.url).href
    },
    scrollTo(elId) {
      const el = document.getElementById(elId)
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' })
        this.$router.replace({ query: { ...this.$router.query, scrollTo: elId } }).catch(() => {})
      }
    },

    setGame({ cards, time }) {
      this.l_game = { cards, time }
    },

    handleScroll() {
      if (this.$refs.fairPlayPicker) {
        this.$refs.fairPlayPicker.handleScroll()
      }
    },
  },
  computed: {
    readMoreLink() {
      return !this.$i18n.g1 ? 'https://blog.gtowizard.com/towards-a-safer-poker-ecosystem/' : ''
    },
    reviews() {
      return [
        {
          img: this.getImage('testimonials/Phil_Nagy2.webp'),
          name: 'Phil Nagy',
          text_g1: `We're thrilled to begin a collaboration with GTO Wizard. Their technology and expertise will be instrumental in both keeping online both fair and secure. Our commitment to this standard remains unwavering.`,
          text: `We're thrilled to begin a collaboration with GTO Wizard. Their technology and expertise will be instrumental in both keeping online poker both fair and secure. Our commitment to this standard remains unwavering.`,
          profession: 'CEO of Winning Poker Network',
          siteLogo: this.getLogo('wpn_removed-trademark-issue.webp'),
        },
        {
          img: this.getImage('testimonials/Baard.webp'),
          name: 'Baard Dhal',
          text_g1: `GTO Wizard has taken training tools to the next level and even beyond and will be the default training tool for any serious player for years to come. More importantly, though, is their commitment to also use their capabilities for the good of all the players. By offering their services to help operators detect those players who are looking to gain unfair advantages, the whole community wins. Here at Playtech, we know firsthand how effective the GTO Wizard tools are in this respect.`,
          text: `GTO Wizard has taken poker training tools to the next level and even beyond and will be the default training tool for any serious poker player for years to come. More importantly, though, is their commitment to also use their capabilities for the good of all of poker. By offering their services to help operators detect those players who are looking to gain unfair advantages, the whole poker community wins. Here at Playtech, we know firsthand how effective the GTO Wizard tools are in this respect.`,
          profession: 'Network Manager of Playtech',
          siteLogo: this.getLogo('ipoker.webp'),
        },
        {
          img: this.getImage('testimonials/alex_scott.webp'),
          name: 'Alex Scott',
          text_g1: `As experienced players, we understand the value of GTO tools in perfecting your game. We also know the dangers if these tools are misused, which is why we invest heavily and work tirelessly to prevent them being used during gameplay. By working in cooperation with GTO Wizard, we hope to further enhance our ability to prevent misuse of GTO software and give players even more reason to trust the safety and security of WPT Global.`,
          text: `As experienced poker players, we understand the value of GTO tools in perfecting your poker game. We also know the dangers if these tools are misused, which is why we invest heavily and work tirelessly to prevent them being used during gameplay. By working in cooperation with GTO Wizard, we hope to further enhance our ability to prevent misuse of GTO software and give poker players even more reason to trust the safety and security of WPT  Global.`,
          profession: 'General Manager at WPT Global',
          siteLogo: this.getLogo('wptglobal1.webp'),
        },
        {
          img: this.getImage('testimonials/Tom_Dwan1.webp'),
          name: 'Tom “durrrr” Dwan',
          text_g1: `It’s crucial to have more good faith and cooperation between different organizations for the integrity of the game. I strongly believe this is an essential and well-intentioned first step towards a more fair game ecosystem. I plan to support and help where I can.`,
          text: `It’s crucial to have more good faith and cooperation between different organizations for the integrity of poker. I strongly believe this is an essential and well-intentioned first step towards a more fair poker ecosystem. I plan to support and help where I can.`,
          profession: 'High Stakes Poker Player',
        },
      ].map(x => ({
        ...x,
        text: this.$i18n.g1 ? x.text_g1 : x.text,
      }))
    },
    boxes() {
      return [
        {
          title: this.$t('fairplay.actions.3.title'),
          icon: 'mdi-handshake',
          description: this.$t('fairplay.actions.3.text'),
          img: this.getImage('boxes/check.webp'),
          onclick: () => this.scrollTo('fairplay'),
          cssClass: 'gw_btn_hover_back cursor-pointer',
        },
        {
          title: this.$t('fairplay.actions.0.title'),
          icon: 'mdi-gamepad-circle',
          description: this.$t('fairplay.actions.0.text'),
          img: this.getImage('boxes/integration1.webp'),
          cssStyles:
            'background-position-x: 1.25rem; background-position-y: -0.4rem; background-repeat: repeat',
        },
        {
          title: this.$t('fairplay.actions.1.title'),
          icon: 'mdi-timer-outline',
          description: this.$t('fairplay.actions.1.text'),
          img: this.getImage('boxes/delays.webp'),
        },
        {
          title: this.$t('fairplay.actions.2.title'),
          icon: 'mdi-shield-account',
          description: this.$t('fairplay.actions.2.text'),
          img: this.getImage('boxes/security.webp'),
        },
        {
          title: this.$t('fairplay.actions.4.title', {
            tooltip: `<span class="csst text-underline">API<div
                  class="csst_content csst_content_hoverable clr-white"
                  style="
                    position: absolute;
                    top: 1.5rem;
                    left: 0;
                    font-size: 0.75rem;
                    padding: 0.2rem;
                    width: clamp(1px, 17rem, 75vw);
                  "
                >${this.$t('fairplay.actions.4.tooltip')}</div></span>`,
          }),
          icon: 'mdi-api-off',
          description: this.$t('fairplay.actions.4.text'),
          img: this.getImage('boxes/noapi.webp'),
        },
        {
          title: this.$t('fairplay.actions.5.title'),
          icon: 'mdi-table-large',
          description: this.$t('fairplay.actions.5.text'),
          img: this.getImage('boxes/reports.webp'),
        },
      ]
    },
  },
}
</script>
<style lang="scss" scoped>
.full-h-border {
  position: relative;
}
.full-h-border::before,
.full-h-border::after {
  content: '';
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 100vw;
  height: 100%;
  background: var(--clr-black-0-1);
  z-index: -1;
}
h2 {
  color: var(--clr-white-0);
  font-weight: 600;
  font-size: 1.75rem;
  margin-bottom: 1.5rem;
}

h3 {
  color: var(--clr-white-0);
  font-weight: 500;
  font-size: 1.5rem;
  text-align: center;
  margin-bottom: 1.75rem;
}

section {
  margin-bottom: 8.5rem;
  position: relative;
  z-index: 1;
}

.frpl {
  color: var(--clr-white-0);
  &_wrapper {
    --gwiz-logo-inline-svg-darker: url("data:image/svg+xml;utf8,<svg fill='rgba(25, 25, 25, 1)' viewBox='0 0 318 238.29' xmlns='http://www.w3.org/2000/svg'><path  d='M257.674 8.91162L220.422 113.784L184.132 13.2131C175.83 13.4667 167.531 13.6174 158.926 13.6174C150.474 13.6174 142.172 13.4643 133.873 13.3638L97.4297 113.832L60.0775 8.80875C38.0101 6.63168 17.8161 3.69623 0 0.0526327L94.6976 236.066C95.3555 235.915 95.9129 235.915 96.3172 235.915C100.619 228.678 145.057 146.835 145.057 146.835L145.311 146.024C146.627 144.962 148.246 144 150.119 143.189C160.141 139.038 160.849 137.976 153.309 139.038C150.88 139.442 148.5 140.253 146.323 141.469L154.775 107.305L133.669 68.4843L188.18 111.861C188.18 111.861 186.56 134.636 190.611 134.636C194.357 134.636 192.634 144.808 192.331 150.024C191.015 149.213 189.242 148.304 187.522 146.935C185.244 145.062 184.182 143.189 183.775 142.227C184.18 143.696 185.091 146.631 186.457 149.213C187.773 151.641 191.67 154.83 193.544 156.45C196.632 166.471 204.678 189.247 212.168 210.152C211.106 209.494 209.74 208.683 208.271 208.025C200.881 204.278 186.051 190.613 184.18 188.893C188.888 196.283 190.455 198.914 195.163 203.874C199.06 208.175 210.448 216.731 215.915 220.728C215.915 220.728 215.915 220.728 216.065 220.879C218.343 227.154 220.47 233.178 222.341 238.291L318 0C300.138 3.69623 279.942 6.63168 257.674 8.91162Z' /></svg>");
    --cc-width: clamp(1px, 62rem, 100vw);
    --cc-width: 62rem;
    overflow-y: auto;
    overflow-x: hidden;
    background: #000;
  }
  &_content {
    width: 100vw;
    max-width: var(--cc-width);
    padding: 0 1rem;
    margin: 0 auto;
  }
  &_header-text {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    margin-top: 5rem;
    gap: 1rem;
  }
  &_main-text {
    font-size: clamp(1px, 6.25rem, 16vw);
    color: var(--clr-white-0);
    grid-column: 1;
    grid-row: 1;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    z-index: 1;
  }

  &_shadow {
    position: absolute;
    font-size: clamp(1px, 6.25rem, 16vw);
    transform: scale(1.2);
    color: transparent;
    letter-spacing: -1px;
    z-index: 0;
    -webkit-text-fill-color: transparent;
    -webkit-text-stroke-width: 1px;
    -webkit-text-stroke-color: rgba(30, 195, 156, 0.4);
  }

  &_header {
    text-align: center;
  }

  &_boxes {
    display: flex;
    gap: 1rem;
    flex-wrap: wrap;
    justify-content: center;
  }

  &_box {
    padding: 1.5rem;
    flex: 1;
    min-width: 18rem;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;

    aspect-ratio: 1 / 1;
    font-size: 1.125rem;
    background-size: cover;
    position: relative;
    background-size: cover;
    border-radius: 8px;
    background-image: linear-gradient(180deg, rgba(17, 17, 17, 0.3), rgb(17, 17, 17)),
      var(--background-url);
  }

  &_buttons {
    display: flex;
    justify-content: center;
    font-weight: 600;
    gap: 1rem;
  }

  &_partners {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    gap: 6rem;
    align-items: center;
    justify-content: center;

    img {
      height: 2.7rem;
    }
  }

  &_divider {
    background: var(--clr-black-4);
    height: 2px;
    width: 100%;
    margin: 1rem 0;
  }

  &_date-button {
    font-size: 1.125rem;
  }

  &_game-select {
    display: flex;
    flex-direction: row;
  }

  &_box_title {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    font-weight: 600;
  }
  &_description {
    font-size: 0.9rem;
    font-weight: 600;
    color: var(--clr-grey-2);
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    height: 3.5rem;
  }

  &_arrow {
    color: var(--clr-primary);
    font-size: 1.5rem;
  }

  &_symbol {
    opacity: 0.8;
    position: absolute;
    z-index: -1;
  }

  &_slider {
    &_wrapper {
      --rrw-height: 18rem;
      --rrw-inset-arrow-left: auto 1.5rem 1.5rem calc(100% - 9.5rem);
      --rrw-inset-arrow-right: auto 1.5rem 1.5rem auto;
    }
    display: flex;
    width: 100%;
    &_avatar {
      aspect-ratio: 1 / 1;
      border-radius: 4px;
      background-size: cover;
      position: relative;
      background-size: cover;
      background-image: var(--background-url);
    }
    &_right {
      display: flex;
      flex-direction: column;
      // margin: 0 0 auto 0;
      &_stars {
        display: flex;
        margin-top: 0.5rem;
      }
      &_text {
        margin-top: 0.5rem;
      }
      &_bio {
        margin-top: 1rem;
        margin-right: auto;
      }
    }
  }
}

.fff-read-more {
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  align-items: center;
}

@media (max-width: 900px) {
  .frpl_symbol_mobile {
    display: none;
  }
  .fff-read-more {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}
@media (max-width: 700px) {
  .frpl_partners {
    gap: 3rem;
  }
  .frpl_slider {
    &_wrapper {
      --rrw-height: 42rem;
      --rrw-inset-arrow-left: auto auto auto 0;
      --rrw-inset-arrow-right: auto 0 auto auto;
    }
    text-align: center;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    &_right {
      padding: 1rem 0 0 0;
      &_stars {
        align-items: center;
        justify-content: center;
      }
      &_text {
        order: 3;
      }
      &_bio {
        margin-right: auto;
        margin-left: auto;
      }
    }
    &_avatar {
      margin: auto;
      --size: 50vw;
      height: var(--size);
      width: var(--size);
    }
  }
  #read_more div {
    margin-left: auto !important;
    margin-right: auto !important;
    gap: 1rem;
  }
}
</style>
